import CommonTitleBar from "components/common/CommonTitleBar";
import NoDataFound from "components/common/NoDataFound";
import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import BranchCard from "./BranchCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllBranches, syncLocks } from "store/actions/branchSlice";
import Spinners from "components/common/Spinners";
import Paginations from "components/common/Paginations";
import { showAlert } from "store/reducers/alertReducer";
import SpaceShimmer from "components/ShimmerEffects/SpaceShimmer";

const Branches = () => {
  const { t } = useTranslation();
  document.title = t("Branches | Da Nonna");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;

  const {
    isLoading,
    loading,
    branches,
    drafts,
    perPage,
    totalCount,
    totalPages,
    currentPage,
  } = useSelector((state) => state.Branches);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = (page) => {
    const payload = {
      perPage,
      pageNo: page || pageNumber,
      status: -1,
      orderBy: -1,
      dateRange: {},
      keyword: "",
    };
    dispatch(getAllBranches(payload));
    navigate(`/management/branches?page=${page || pageNumber}`);
  };

  const handleSyncLocks = () => {
    dispatch(syncLocks())
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <React.Fragment>
      <div className="page-content common_page">
        <Container fluid>
          <CommonTitleBar
            title={t("Branches")}
            isCreateBtn={true}
            createBtnText={t("Add New")}
            onCreateBtnClick={() => navigate("/management/branches/add-branch")}
            // isCreateBtn2={true}
            createBtnText2={t("Sync Locks")}
            onCreateBtnClick2={handleSyncLocks}
            isLoading={isLoading}
          />
          <div className="common_wrapper">
            <Row className="branches_row">
              {loading ? (
                <SpaceShimmer col={4} />
              ) : branches?.length === 0 ? (
                <NoDataFound />
              ) : (
                branches?.map((item) => (
                  <BranchCard
                    key={item?._id}
                    item={item}
                    isLoading={isLoading}
                  />
                ))
              )}
            </Row>
          </div>
          <h2 className="main_title">{t("Draft")}</h2>
          <div className="common_wrapper">
            {loading ? (
              <SpaceShimmer col={4} />
            ) : drafts?.length === 0 ? (
              <NoDataFound text={t("No drafts saved yet")} />
            ) : (
              <Row>
                {drafts?.map((item) => (
                  <BranchCard
                    key={item?._id}
                    item={item}
                    className="draft"
                    isLoading={isLoading}
                  />
                ))}
              </Row>
            )}
          </div>
          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Branches;
